// Shared sport definitions — used across Directory, Admin forms, Profiles
export const SPORTS = {
  football: {
    id: "football",
    label: "Football",
    icon: "⚽",
    color: "#0066FF",
    player_stats: [
      { key: "matches", label: "Matchs" },
      { key: "goals", label: "Buts" },
      { key: "assists", label: "Passes décisives" },
      { key: "cards", label: "Cartons" },
    ],
    tournament_stats: [
      { key: "total_matches", label: "Matchs" },
      { key: "total_goals", label: "Buts" },
    ],
    standings_columns: [
      { key: "matches_played", label: "MJ" },
      { key: "wins", label: "V" },
      { key: "draws", label: "N" },
      { key: "losses", label: "D" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Gardien", "Défenseur", "Latéral", "Milieu Défensif", "Milieu Offensif", "Ailier", "Attaquant"],
  },
  tennis: {
    id: "tennis",
    label: "Tennis",
    icon: "🎾",
    color: "#D4AF37",
    player_stats: [
      { key: "matches", label: "Matchs joués" },
      { key: "sets_won", label: "Sets gagnés" },
      { key: "aces", label: "Aces" },
      { key: "double_faults", label: "Doubles fautes" },
    ],
    tournament_stats: [
      { key: "total_matches", label: "Matchs" },
      { key: "total_sets", label: "Sets joués" },
      { key: "total_aces", label: "Aces" },
    ],
    standings_columns: [
      { key: "wins", label: "V" },
      { key: "losses", label: "D" },
      { key: "sets_won", label: "Sets" },
      { key: "points", label: "ATP" },
    ],
    positions: ["Simple", "Double", "Mixte"],
  },
  basket: {
    id: "basket",
    label: "Basket",
    icon: "🏀",
    color: "#FF6B1A",
    player_stats: [
      { key: "matches", label: "Matchs" },
      { key: "points", label: "Points" },
      { key: "rebounds", label: "Rebonds" },
      { key: "assists", label: "Passes" },
    ],
    tournament_stats: [
      { key: "total_matches", label: "Matchs" },
      { key: "total_points", label: "Points" },
      { key: "total_rebounds", label: "Rebonds" },
    ],
    standings_columns: [
      { key: "matches_played", label: "MJ" },
      { key: "wins", label: "V" },
      { key: "losses", label: "D" },
      { key: "points_scored", label: "PM" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Meneur", "Arrière", "Ailier", "Ailier Fort", "Pivot"],
  },
  voile: {
    id: "voile",
    label: "Voile",
    icon: "⛵",
    color: "#00A2E8",
    player_stats: [
      { key: "regattas", label: "Régates" },
      { key: "wins", label: "Victoires" },
      { key: "podiums", label: "Podiums" },
      { key: "points", label: "Points" },
    ],
    tournament_stats: [
      { key: "total_races", label: "Régates" },
      { key: "total_boats", label: "Bateaux" },
      { key: "total_nautical_miles", label: "Milles nautiques" },
      { key: "total_players", label: "Skippers" },
    ],
    standings_columns: [
      { key: "regattas", label: "R" },
      { key: "wins", label: "V" },
      { key: "podiums", label: "Pod" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Skipper", "Équipier", "Tacticien", "Barreur"],
  },
  ski: {
    id: "ski",
    label: "Ski",
    icon: "⛷️",
    color: "#E11D48",
    player_stats: [
      { key: "races", label: "Courses" },
      { key: "wins", label: "Victoires" },
      { key: "podiums", label: "Podiums" },
      { key: "top_10", label: "Top 10" },
    ],
    tournament_stats: [
      { key: "total_races", label: "Courses" },
      { key: "total_skiers", label: "Skieurs" },
      { key: "best_time", label: "Meilleur temps" },
      { key: "snow_quality", label: "Qualité neige /10" },
    ],
    standings_columns: [
      { key: "races", label: "C" },
      { key: "wins", label: "V" },
      { key: "podiums", label: "Pod" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Slalom", "Slalom Géant", "Super-G", "Descente", "Combiné", "Skicross", "Freestyle"],
  },
  hockey: {
    id: "hockey",
    label: "Hockey",
    icon: "🏒",
    color: "#0EA5E9",
    player_stats: [
      { key: "matches", label: "Matchs" },
      { key: "goals", label: "Buts" },
      { key: "assists", label: "Assists" },
      { key: "plus_minus", label: "Plus/Moins" },
    ],
    tournament_stats: [
      { key: "total_matches", label: "Matchs" },
      { key: "total_goals", label: "Buts" },
    ],
    standings_columns: [
      { key: "matches_played", label: "MJ" },
      { key: "wins", label: "V" },
      { key: "ot_wins", label: "VP" },
      { key: "losses", label: "D" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Gardien", "Défenseur", "Centre", "Ailier Gauche", "Ailier Droit"],
  },
  rugby: {
    id: "rugby",
    label: "Rugby",
    icon: "🏉",
    color: "#15803D",
    player_stats: [
      { key: "matches", label: "Matchs" },
      { key: "tries", label: "Essais" },
      { key: "conversions", label: "Transfos" },
      { key: "tackles", label: "Plaquages" },
    ],
    tournament_stats: [
      { key: "total_matches", label: "Matchs" },
      { key: "total_tries", label: "Essais" },
      { key: "total_points", label: "Points" },
    ],
    standings_columns: [
      { key: "matches_played", label: "MJ" },
      { key: "wins", label: "V" },
      { key: "draws", label: "N" },
      { key: "losses", label: "D" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Pilier", "Talonneur", "2ème ligne", "3ème ligne", "Demi de mêlée", "Demi d'ouverture", "Centre", "Ailier", "Arrière"],
  },
  athletisme: {
    id: "athletisme",
    label: "Athlétisme",
    icon: "🏃",
    color: "#F59E0B",
    player_stats: [
      { key: "competitions", label: "Compétitions" },
      { key: "gold", label: "Or" },
      { key: "silver", label: "Argent" },
      { key: "bronze", label: "Bronze" },
    ],
    tournament_stats: [
      { key: "total_events", label: "Épreuves" },
      { key: "total_athletes", label: "Athlètes" },
      { key: "records_broken", label: "Records battus" },
      { key: "total_medals", label: "Médailles" },
    ],
    standings_columns: [
      { key: "gold", label: "Or" },
      { key: "silver", label: "Arg" },
      { key: "bronze", label: "Bro" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Sprint", "Demi-fond", "Fond", "Saut en hauteur", "Saut en longueur", "Triple saut", "Lancer du poids", "Lancer du javelot", "Décathlon", "Heptathlon"],
  },
  cyclisme: {
    id: "cyclisme",
    label: "Cyclisme",
    icon: "🚴",
    color: "#A855F7",
    player_stats: [
      { key: "races", label: "Courses" },
      { key: "wins", label: "Victoires" },
      { key: "podiums", label: "Podiums" },
      { key: "kilometers", label: "Kilomètres" },
    ],
    tournament_stats: [
      { key: "total_stages", label: "Étapes" },
      { key: "total_riders", label: "Coureurs" },
      { key: "total_kilometers", label: "Kilomètres" },
      { key: "elevation_gain", label: "Dénivelé (m)" },
    ],
    standings_columns: [
      { key: "races", label: "C" },
      { key: "wins", label: "V" },
      { key: "podiums", label: "Pod" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Sprinteur", "Grimpeur", "Rouleur", "Puncheur", "Contre-la-montre", "VTT", "BMX", "Cyclo-cross"],
  },
  natation: {
    id: "natation",
    label: "Natation",
    icon: "🏊",
    color: "#06B6D4",
    player_stats: [
      { key: "competitions", label: "Compétitions" },
      { key: "gold", label: "Or" },
      { key: "silver", label: "Argent" },
      { key: "bronze", label: "Bronze" },
    ],
    tournament_stats: [
      { key: "total_races", label: "Courses" },
      { key: "total_swimmers", label: "Nageurs" },
      { key: "records_broken", label: "Records" },
      { key: "total_medals", label: "Médailles" },
    ],
    standings_columns: [
      { key: "gold", label: "Or" },
      { key: "silver", label: "Arg" },
      { key: "bronze", label: "Bro" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Crawl", "Dos", "Brasse", "Papillon", "4 nages", "Eau libre", "Plongeon"],
  },
  golf: {
    id: "golf",
    label: "Golf",
    icon: "⛳",
    color: "#65A30D",
    player_stats: [
      { key: "tournaments", label: "Tournois" },
      { key: "wins", label: "Victoires" },
      { key: "best_score", label: "Meilleur score" },
      { key: "handicap", label: "Handicap" },
    ],
    tournament_stats: [
      { key: "total_rounds", label: "Tours" },
      { key: "course_par", label: "Par du parcours" },
      { key: "total_holes", label: "Trous joués" },
    ],
    standings_columns: [
      { key: "rounds", label: "T" },
      { key: "wins", label: "V" },
      { key: "cuts_made", label: "Cuts" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Amateur", "Pro", "Senior", "Junior", "Mid-Amateur"],
  },
  padel: {
    id: "padel",
    label: "Padel",
    icon: "🎾",
    color: "#14B8A6",
    player_stats: [
      { key: "matches", label: "Matchs" },
      { key: "wins", label: "Victoires" },
      { key: "losses", label: "Défaites" },
      { key: "smashes", label: "Smashs" },
    ],
    tournament_stats: [
      { key: "total_matches", label: "Matchs" },
      { key: "total_pairs", label: "Paires" },
      { key: "total_sets", label: "Sets joués" },
    ],
    standings_columns: [
      { key: "matches_played", label: "MJ" },
      { key: "wins", label: "V" },
      { key: "losses", label: "D" },
      { key: "sets_won", label: "Sets" },
      { key: "points", label: "PTS" },
    ],
    positions: ["Côté droit", "Côté gauche", "Mixte"],
  },
  auto: {
    id: "auto",
    label: "Sports auto",
    icon: "🏎️",
    color: "#FF1801",
    player_stats: [
      { key: "wins", label: "Victoires" },
      { key: "podiums", label: "Podiums" },
      { key: "poles", label: "Poles" },
      { key: "fastest_laps", label: "Meilleurs tours" },
    ],
    tournament_stats: [
      { key: "total_races", label: "Courses" },
      { key: "total_drivers", label: "Pilotes" },
      { key: "total_kilometers", label: "Kilomètres" },
      { key: "total_teams", label: "Écuries" },
    ],
    standings_columns: [
      { key: "races", label: "C" },
      { key: "wins", label: "V" },
      { key: "podiums", label: "Pod" },
      { key: "points", label: "PTS" },
    ],
    positions: [
      "Karting",
      "Formule 4",
      "Formule 3",
      "Formule 2",
      "Formule 1",
      "Rallye",
      "Drift",
      "Course de côte",
      "Endurance",
      "GT",
    ],
  },
  moto: {
    id: "moto",
    label: "Moto",
    icon: "🏍️",
    color: "#EC4899",
    player_stats: [
      { key: "wins", label: "Victoires" },
      { key: "podiums", label: "Podiums" },
      { key: "poles", label: "Poles" },
      { key: "fastest_laps", label: "Meilleurs tours" },
    ],
    tournament_stats: [
      { key: "total_races", label: "Courses" },
      { key: "total_riders", label: "Pilotes" },
      { key: "total_kilometers", label: "Kilomètres" },
      { key: "total_teams", label: "Teams" },
    ],
    standings_columns: [
      { key: "races", label: "C" },
      { key: "wins", label: "V" },
      { key: "podiums", label: "Pod" },
      { key: "points", label: "PTS" },
    ],
    positions: [
      "MotoGP",
      "Moto2",
      "Moto3",
      "Superbike",
      "Supersport",
      "Motocross",
      "Enduro",
      "Supermotard",
      "Trial",
      "Vitesse",
      "Rallye-raid",
    ],
  },
  danse: {
    id: "danse",
    label: "Danse",
    icon: "💃",
    color: "#C026D3",
    player_stats: [
      { key: "competitions", label: "Concours" },
      { key: "wins", label: "Victoires" },
      { key: "podiums", label: "Podiums" },
      { key: "performances", label: "Représentations" },
    ],
    tournament_stats: [
      { key: "total_performances", label: "Passages" },
      { key: "total_dancers", label: "Danseurs" },
      { key: "total_groups", label: "Groupes" },
    ],
    standings_columns: [
      { key: "performances", label: "P" },
      { key: "wins", label: "V" },
      { key: "podiums", label: "Pod" },
      { key: "points", label: "PTS" },
    ],
    positions: [
      "Danse contemporaine",
      "Folklore",
      "Hip-hop",
      "Danses latines",
      "Jazz",
      "Urbain",
      "K-pop",
      "Classique",
      "Modern jazz",
      "Breakdance",
      "Salsa",
      "Bachata",
      "Danse de salon",
    ],
  },
  arts_martiaux: {
    id: "arts_martiaux",
    label: "Arts martiaux",
    icon: "🥋",
    color: "#DC2626",
    player_stats: [
      { key: "fights", label: "Combats" },
      { key: "wins", label: "Victoires" },
      { key: "ko_ippon", label: "KO / Ippon" },
      { key: "podiums", label: "Podiums" },
    ],
    tournament_stats: [
      { key: "total_fights", label: "Combats" },
      { key: "total_athletes", label: "Athlètes" },
      { key: "total_categories", label: "Catégories" },
      { key: "total_medals", label: "Médailles" },
    ],
    standings_columns: [
      { key: "fights", label: "C" },
      { key: "wins", label: "V" },
      { key: "ko_ippon", label: "KO" },
      { key: "points", label: "PTS" },
    ],
    positions: [
      "Karaté",
      "Judo",
      "Taekwondo",
      "Jiu-Jitsu Brésilien",
      "Boxe",
      "Kickboxing",
      "MMA",
      "Aïkido",
      "Muay Thai",
      "Kung Fu",
    ],
  },
};

export const SPORT_IDS = Object.keys(SPORTS);

export const getSport = (id) => SPORTS[id] || SPORTS.football;

// ---------- Sports individuels vs sports d'équipe ----------
const INDIVIDUAL_SPORTS = new Set([
  "tennis", "voile", "ski", "athletisme", "cyclisme", "natation", "golf", "arts_martiaux", "auto", "moto", "danse",
]);
Object.keys(SPORTS).forEach((id) => {
  SPORTS[id].individual = INDIVIDUAL_SPORTS.has(id);
});

// ---------- Barème de points par sport (null = saisie manuelle) ----------
const SPORT_SCORING = {
  football: { wins: 3, draws: 1, losses: 0 },
  basket: { wins: 2, losses: 1 },
  hockey: { wins: 3, ot_wins: 2, losses: 0 },
  rugby: { wins: 4, draws: 2, losses: 0 },
  athletisme: { gold: 3, silver: 2, bronze: 1 },
  natation: { gold: 3, silver: 2, bronze: 1 },
  padel: { wins: 2, losses: 0 },
  arts_martiaux: { wins: 3, ko_ippon: 1 },
  // Barème par position type F1 (points par place d'arrivée)
  auto: { p1: 25, p2: 18, p3: 15, p4: 12, p5: 10, p6: 8, p7: 6, p8: 4, p9: 2, p10: 1 },
  moto: { p1: 25, p2: 20, p3: 16, p4: 13, p5: 11, p6: 10, p7: 9, p8: 8, p9: 7, p10: 6 },
};
// Sports où les points se calculent depuis les arrivées par position (P1, P2, …)
const POSITION_SCORING_SPORTS = new Set(["auto", "moto"]);
Object.keys(SPORTS).forEach((id) => {
  SPORTS[id].scoring = SPORT_SCORING[id] || null;
  SPORTS[id].position_scoring = POSITION_SCORING_SPORTS.has(id);
});

// ---------- Récompenses suggérées par sport ----------
const SPORT_AWARDS = {
  football: ["Champion", "Meilleur buteur", "Meilleur gardien", "Meilleur passeur", "Joueur de la saison"],
  tennis: ["Vainqueur", "Finaliste", "Meilleur serveur", "Révélation du tournoi"],
  basket: ["Champion", "MVP", "Meilleur marqueur", "Meilleur rebondeur", "Meilleur passeur"],
  auto: ["Champion", "Meilleur rookie", "Record de pole positions", "Meilleur tour en course"],
  moto: ["Champion", "Meilleur rookie", "Record de poles", "Meilleur tour en course"],
  hockey: ["Champion", "MVP", "Meilleur buteur", "Meilleur gardien"],
  rugby: ["Champion", "Meilleur marqueur d'essais", "Meilleur buteur", "Joueur de la saison"],
  padel: ["Vainqueurs", "Finalistes", "Meilleure paire", "Révélation du tournoi"],
  voile: ["Vainqueur", "Meilleur skipper", "Meilleure régate"],
  ski: ["Champion", "Meilleur temps", "Révélation de la saison"],
  athletisme: ["Champion", "Record du meeting", "Révélation"],
  cyclisme: ["Vainqueur du général", "Meilleur grimpeur", "Meilleur sprinteur", "Meilleur jeune"],
  natation: ["Champion", "Record du bassin", "Révélation"],
  golf: ["Vainqueur", "Meilleure carte", "Longest drive"],
  arts_martiaux: ["Champion", "Meilleur combattant", "Esprit du tournoi"],
  danse: ["Vainqueur", "Meilleure chorégraphie", "Meilleur danseur", "Meilleure danseuse", "Coup de cœur du jury"],
};
Object.keys(SPORTS).forEach((id) => {
  SPORTS[id].awards = SPORT_AWARDS[id] || ["Champion", "MVP", "Révélation"];
});

export const SCORING_LABELS = {
  wins: "Victoire",
  draws: "Match nul",
  losses: "Défaite",
  ot_wins: "Victoire prolong.",
  gold: "Médaille d'or",
  silver: "Médaille d'argent",
  bronze: "Médaille de bronze",
  ko_ippon: "KO / Ippon (bonus)",
  p1: "1ᵉʳ",
  p2: "2ᵉ",
  p3: "3ᵉ",
  p4: "4ᵉ",
  p5: "5ᵉ",
  p6: "6ᵉ",
  p7: "7ᵉ",
  p8: "8ᵉ",
  p9: "9ᵉ",
  p10: "10ᵉ",
};

// Clés de positions (p1, p2, …) du barème d'un sport à positions
export const positionKeys = (sportId) => {
  const base = SPORTS[sportId]?.scoring;
  if (!base || !SPORTS[sportId]?.position_scoring) return [];
  return Object.keys(base).filter((k) => /^p\d+$/.test(k));
};

// Dérive V / Pod depuis les arrivées par position d'une ligne pilote
export const derivePositionStats = (row) => ({
  wins: Number(row.p1) || 0,
  podiums: (Number(row.p1) || 0) + (Number(row.p2) || 0) + (Number(row.p3) || 0),
});

// Barème effectif : personnalisé s'il existe, sinon défaut du sport
export const effectiveScoring = (sportId, custom) => {
  const base = SPORTS[sportId]?.scoring;
  if (!base) return null;
  return custom && Object.keys(custom).length ? custom : base;
};

export const computePoints = (row, scoring) => {
  if (!scoring) return null;
  return Object.entries(scoring).reduce(
    (sum, [k, w]) => sum + (Number(row[k]) || 0) * (Number(w) || 0),
    0,
  );
};

// Terminologie adaptée au type de sport (équipe vs individuel)
export const sportTerms = (sportId) => {
  if (sportId === "auto" || sportId === "moto") {
    return {
      individual: true,
      entity: "Pilote",
      entities: "Pilotes",
      standings: "Classement pilotes",
      finalStandings: "Classement final pilotes",
      add: "Ajouter un pilote",
      participants: "Pilotes engagés",
      namePlaceholder: "Nom du pilote",
      countLabel: "pilotes",
    };
  }
  if (sportId === "tennis" || sportId === "padel") {
    return {
      individual: true,
      entity: "Joueur",
      entities: "Joueurs",
      standings: "Classement joueurs",
      finalStandings: "Classement final",
      add: "Ajouter un joueur",
      participants: "Joueurs",
      namePlaceholder: "Nom du joueur",
      countLabel: "joueurs",
    };
  }
  if (sportId === "danse") {
    return {
      individual: true,
      entity: "Danseur",
      entities: "Danseurs",
      standings: "Classement",
      finalStandings: "Classement final",
      add: "Ajouter un danseur / groupe",
      participants: "Danseurs & Groupes",
      namePlaceholder: "Nom du danseur ou du groupe",
      countLabel: "danseurs",
    };
  }
  const ind = SPORTS[sportId]?.individual;
  return ind
    ? {
        individual: true,
        entity: "Athlète",
        entities: "Athlètes",
        standings: "Classement individuel",
        finalStandings: "Classement final individuel",
        add: "Ajouter un athlète",
        participants: "Athlètes participants",
        namePlaceholder: "Nom de l'athlète",
        countLabel: "athlètes",
      }
    : {
        individual: false,
        entity: "Équipe",
        entities: "Équipes",
        standings: "Classement",
        finalStandings: "Classement final",
        add: "Ajouter une équipe",
        participants: "Équipes participantes",
        namePlaceholder: "Nom de l'équipe",
        countLabel: "équipes",
      };
};
